import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {MainMiniCommon} from './main/MainMiniCommon';

export interface IDashboardMiniViewProps {
    dashboard: any;
}

@observer
export class DashboardMiniView extends TechseeBaseComponent<IDashboardMiniViewProps> {
    renderInternal(): JSX.Element {
        const {dashboard} = this.props;
        const dashboardState = dashboard?.dashboardState;

        if (!dashboardState?.dashboardControllerLoaded || !dashboard.miniDashboard) {
            return <React.Fragment />;
        }

        return (
            <div className='dashboard-container ts-vertical-layout'>
                <div className='dashboard-main-area'>
                    {/* Main Content - replaces ui-view="mini-dashboard-view" */}
                    <div className='dashboard-content-area' role='layout'>
                        <MainMiniCommon main={dashboard} containerClassName='ts-dashboard-mini-dashboard-container' />
                    </div>
                </div>
            </div>
        );
    }
}
